export default {
  'paymentList.title': 'Payment List',
  'paymentList.form.profileName': 'Configuration Name',
  'paymentList.form.profileName.placeholder':
    'Please select configuration name',
  'paymentList.form.search': 'Query',
  'paymentList.form.reset': 'Reset',
  'paymentList.operation.add': 'Add New',
  'paymentList.operation.delete': 'Delete',
  'paymentList.columns.merchant': 'Merchant Name',
  'paymentList.columns.profileName': 'Configuration Name',
  'paymentList.columns.profileType': 'Configuration Type',
  'paymentList.columns.status': 'Status',
  'paymentList.columns.createdAt': 'Creation Time',
  'paymentList.columns.updatedAt': 'Update Time',
  'paymentList.columns.operations': 'Operations',
  'paymentList.columns.operations.view': 'View',
  'paymentList.modal.view': 'View Payment Profile',
  'paymentList.columns.operations.edit': 'Edit',
  'paymentList.columns.operations.duplicate': 'Duplicate',
  'paymentList.columns.operations.delete': 'Delete',
  'paymentList.columns.operations.deleteConfirm':
    'Are you sure you want to delete this record?',
  'paymentList.status.active': 'Active',
  'paymentList.status.inactive': 'Inactive',
  'paymentList.profileType.card': 'Credit Card',
  'paymentList.profileType.scard': 'Renewal Credit Card',
  'paymentList.profileType.paypal': 'Paypal',
  'paymentList.profileType.additional': 'Local Payment',
  'paymentList.delete.confirm':
    'Are you sure you want to delete the selected configuration?',
  'paymentList.delete.success': 'Delete successful',
  'paymentList.delete.failed': 'Delete failed',
  'paymentList.delete.noSelection':
    'Please select a configuration to delete first',
  'paymentList.duplicate.success': 'Duplicate successful',
  'paymentList.duplicate.failed': 'Duplicate failed',
  'paymentList.modal.add': 'Add Payment Configuration',
  'paymentList.modal.profileName': 'Configuration Name',
  'paymentList.modal.profileName.placeholder':
    'Please enter configuration name',
  'paymentList.modal.profileName.required': 'Please enter configuration name',
  'paymentList.modal.profileType': 'Configuration Type',
  'paymentList.modal.profileType.placeholder':
    'Please select configuration type',
  'paymentList.modal.profileType.required': 'Please select configuration type',
  'paymentList.modal.merchant': 'Merchant',
  'paymentList.modal.merchant.required': 'Please select merchant',
  'paymentList.modal.gateways': 'Gateway List',
  'paymentList.modal.gateways.required': 'Please select at least one gateway',
  'paymentList.modal.fetchGatewayFailed': 'Failed to fetch gateway list',
  'paymentList.modal.createSuccess': 'Create successful',
  'paymentList.modal.createFailed': 'Create failed',
  'paymentList.modal.edit': 'Edit Payment Configuration',
  'paymentList.modal.updateSuccess': 'Update successful',
  'paymentList.modal.updateFailed': 'Update failed',
  'paymentList.gateway.columns.alias': 'Alias',
  'paymentList.gateway.columns.gatewayType': 'Gateway Type',
  'paymentList.gateway.columns.status': 'Status',
  'paymentList.edit.selectedGateways': 'Selected Gateways',
  'paymentList.edit.dragToSort': 'Drag to Sort',
  'paymentList.edit.noSelectedGateways': 'No selected gateways',
  'paymentList.edit.allGateways': 'All Gateways',
  'paymentList.edit.searchGateway': 'Search Gateway',
  'paymentList.edit.noAvailableGateways': 'No available gateways',
  'paymentList.edit.save': 'Save',
  'paymentList.edit.create': 'Create',
  'paymentList.edit.cancel': 'Cancel and Return',
  'paymentList.edit.gatewayNotActive':
    'This gateway is not in normal status and cannot be added',
  'paymentList.edit.loadDetailFailed':
    'Failed to load payment configuration details',
  'paymentList.edit.merchantInfoError':
    'Unable to get merchant information, please refresh the page and try again',
};
